import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

/*
  STYLES
*/

export const HeaderSubNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;

  /* If there are no elements inside this wrapper, set it to display:none
     so that the header doesn't add a gap */
  &:empty {
    display: none;
  }
`

export const HeaderSubNavDivider = styled.div`
  width: 1px;
  height: 26px;
  background: ${colors.translucentWhite30};
`
